module.exports = __webpack_public_path__ + "static/billsby-member-site-9a4b084ae7b657751ef45fc3e9bbc3a3.svg";